import React from "react";
import { Form, Input } from "antd";

const { TextArea } = Input;

function Recommendations() {
  return (
    <>
      <div className="custom-title !text-[#111928] rounded-[.5rem]">
        Recommendations
      </div>
      <Form.Item name="recommendations" label={"Recommendations"}>
        <TextArea rows={3} className="text_area" />
      </Form.Item>
    </>
  );
}

export default Recommendations;
